import { StatusCodes } from 'http-status-codes'

const { INTERNAL_SERVER_ERROR } = StatusCodes

export interface ApiError {
  application: string
  code: string
  detail: string
  instance: string
  status: number
  title: string
  type: string
  id?: string
  timestamp?: string
}

export class SalesApiError extends Error implements ApiError {
  application: string
  code: string
  detail: string
  instance: string
  status: number
  title: string
  type: string
  // eslint-disable-next-line @typescript-eslint/member-ordering
  id?: string
  timestamp?: string

  constructor(message?: string, code?: string, status = INTERNAL_SERVER_ERROR) {
    super(message)
    this.application = 'sales'
    this.code = code ?? 'UNKNOWN'
    this.instance = ''
    this.detail = message ?? 'Unexpected error'
    this.status = status
    this.title = message ?? 'Unexpected error'
    this.type = `https://bora.systems/errors/${this.code}`
    this.timestamp = new Date().toISOString()
  }

  toPlainObject(): ApiError {
    return {
      application: this.application,
      code: this.code,
      detail: this.detail,
      instance: this.instance,
      status: this.status,
      title: this.title,
      type: this.type,
      id: this.id,
      timestamp: this.timestamp,
    }
  }
}
